export default __webpack_public_path__ + "c14ba11.png";